var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-input',_vm._b({staticClass:"va-rich-text-input"},'va-input',_vm.$props,false),[_c('editor',{attrs:{"init":_vm.getInit,"value":_vm.input},on:{"change":_vm.change,"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }